export default {
  SET_BRAND_DETAIL(state, payload) {
    state[payload.key] = payload.value;
  }
};
